/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-seniorities" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-seniorities" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-seniorities" */ `./edit.vue` );

export default {
	path: `seniorities`,
	children: [
		{
			path: ``,
			name: `list-seniorities`,
			component: List,
			meta: {
				title: `Seniorities`
			}
		},
		{
			path: `new`,
			name: `add-seniorities`,
			component: Add,
			meta: {
				title: `Add Seniority`
			}
		},
		{
			path: `:uuid`,
			name: `edit-seniorities`,
			component: Edit,
			meta: {
				title: `Edit Seniority`
			}
		}
	]
};
